import Box from '@mui/material/Box';
import { PropsWithChildren, ReactElement } from 'react';
import { fieldBoxInnerSx, fieldBoxRootSx } from './styles';

export function FieldBox({
  children,
  dataQa,
}: PropsWithChildren<{ dataQa?: string }>): ReactElement {
  return (
    <Box sx={fieldBoxRootSx} data-qa={dataQa}>
      <Box sx={fieldBoxInnerSx}>{children}</Box>
    </Box>
  );
}
